import React from "react";

const VideoDetail = ({ video }) => {
    console.log(video);
    if (!video) {
        return <div>Video load nh hui</div>
    }

    const URL = `https://www.youtube.com/embed/${video.id.videoId}`
    return (
        <div>
            <div className="ui embed">
                <iframe title="video player" src={URL}></iframe>
            </div>
            <div className="ui segment">
                <h4 className="ui header">{video.snippet.title}</h4>
                <div>{video.snippet.description}</div>
            </div>
        </div>
    );
};

export default VideoDetail;